var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRehausse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.7,
    height: 481.3,
    viewBox: "0 0 74 361"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3c-3 2-6 4-7 7-2 4-2 5-2 178v173h74V12l-6-6-6-6H13L9 3z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9Ijk4LjciIGhlaWdodD0iNDgxLjMiIHZpZXdCb3g9IjAgMCA3NCAzNjEiPjxwYXRoIGQ9Ik05IDNjLTMgMi02IDQtNyA3LTIgNC0yIDUtMiAxNzh2MTczaDc0VjEybC02LTYtNi02SDEzTDkgM3oiLz48L3N2Zz4=";
export { SvgRehausse as ReactComponent };